import { IsOptional, IsString } from 'class-validator';
import { BaseSearchQueryParamsDto } from './baseSearchQueryParams.dto';

export class CustomerSearchQueryParamsDto extends BaseSearchQueryParamsDto {
  @IsOptional()
  @IsString()
  email: string;

  @IsOptional()
  @IsString()
  phone: string;
}
